export const name = 'builderComponent' as const
export const BuilderComponentLoaderSymbol = Symbol('BuilderComponentLoader')
export const BuilderComponentRegistrarSymbol = Symbol('BuilderComponentRegistrar')
export const BuilderComponentStyleApiSymbol = Symbol('BuilderComponentStyleApi')
export const BuilderComponentResolverSymbol = Symbol('BuilderComponentResolver')
export const BuilderComponentWarmupDataEnricherSymbol = Symbol('BuilderComponentWarmupDataEnricher')
export const BuilderResourcesManagerSymbol = Symbol('BuilderResourcesManager')
export const CompTypeToAllDescendantsHandlerSymbol = Symbol('CompTypeToAllDescendantsHandler')
